import { createFileRoute, stripSearchParams } from '@tanstack/react-router'

import { EmployeeEditPage } from '@/features/org/components/employee-form-page'
import { EMPLOYEES_SEARCH_DEFAULTS, employeesSearchSchema } from '@/features/org/search-schema'

/**
 * /employees/$employeeId/edit —— 编辑员工(改名 / 调队 / 启停用)。
 *
 * 本域没有员工详情页:`EmployeeSerializer` 是 list / detail 共用的单一投影,
 * 列表那一屏已经是全部字段面,再造一个只读详情页只是多一次点击。
 * 与新建页同样复用列表 search schema,保证「带着筛选进来、带着筛选回去」。
 */
export const Route = createFileRoute('/_authed/employees/$employeeId/edit')({
  validateSearch: employeesSearchSchema,
  search: {
    middlewares: [stripSearchParams(EMPLOYEES_SEARCH_DEFAULTS)],
  },
  component: EmployeeEditPage,
})
